/**
 * Elapsed time the way a person says it: "45s", "12m", "2h 15m", "3d 0h".
 *
 * Only the two largest units are shown — past a day, minutes are noise, and a
 * single unit ("4320m") is unreadable at that size. Each unit is floored, so
 * a value never claims more time than actually passed. A negative or
 * non-finite input is not a duration and renders as '—'.
 */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—';
  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds.toString()}s`;
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) return `${totalMinutes.toString()}m`;
  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) return `${totalHours.toString()}h ${(totalMinutes % 60).toString()}m`;
  const days = Math.floor(totalHours / 24);
  return `${days.toString()}d ${(totalHours % 24).toString()}h`;
}

/** {@link formatDuration} of `end − start`, both ISO timestamps. */
export function formatDurationBetween(startIso: string, endIso: string): string {
  return formatDuration(new Date(endIso).getTime() - new Date(startIso).getTime());
}
